export default __webpack_public_path__ + "static/form-multiple-action-buttons-do-dac58a18ae8a30735974a8480863160c.png";